import React from 'react';
import {
	BasePropsOfComponentForRenderer,
	TooltipRendererFields,
	TooltipRendererCreatorService,
} from '../../TooltipRendererCreator.service';
import {
	IDetailsColumnRenderTooltipProps,
	IDetailsHeaderProps,
	IRenderFunction,
} from 'components/FluentUICompat';
import {
	DetailsListHeaderTooltip,
	PropsOfHeaderTooltipRenderer,
} from './DetailsListHeaderTooltip/DetailsListHeaderTooltip';

type PossibleElement = JSX.Element | null;

type Props = BasePropsOfComponentForRenderer<IDetailsHeaderProps>;

/**
 * * Note
 *
 * This component does not throw an error when the field name is missing. See
 * below to understand why.
 */
export function DetailsListHeaderWithTooltips({
	defaultRender,
	originalComponentProps: possibleOriginalProps,
}: Props): React.ReactElement {
	type RendererFields = TooltipRendererFields<
		null,
		PropsOfHeaderTooltipRenderer
	>;

	const renderTooltip = ({props}: RendererFields): PossibleElement => {
		return <DetailsListHeaderTooltip {...props} />;
	};

	const {getCallRendererIfDefaultOneExists} =
		new TooltipRendererCreatorService();

	const onRenderColumnHeaderTooltip: IRenderFunction<IDetailsColumnRenderTooltipProps> =
		getCallRendererIfDefaultOneExists(null, renderTooltip);

	const renderDefaultHeader = (
		originalProps: IDetailsHeaderProps,
	): React.ReactElement => {
		return (
			defaultRender({...originalProps, onRenderColumnHeaderTooltip}) || <></>
		);
	};

	if (!possibleOriginalProps) return <></>;
	return renderDefaultHeader(possibleOriginalProps);
}
